import { Link } from "react-router-dom";
import { ArrowRight, History } from "lucide-react";
import { abs } from "@/lib/api";
import { TerminalStats } from "@/components/home/Motion";

export const TerminalCard = ({ t, stats }) => (
  <Link to={`/terminaller/${t.slug}`} className="group flex flex-col overflow-hidden rounded-md border border-line bg-white transition-[border-color,box-shadow,transform] duration-200 hover:-translate-y-0.5 hover:border-navy/40 hover:shadow-md"
    data-testid={`terminal-card-${t.slug}`}>
    <div className="relative aspect-[4/3] overflow-hidden bg-paper">
      {t.photo_info && (
        <img src={abs(t.photo_info.url)} alt={t.photo_alt} loading="lazy" width={t.photo_info.width} height={t.photo_info.height}
          className={`h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.02] ${t.status === "historical" ? "grayscale-[60%]" : ""}`} />
      )}
      {t.status === "historical" && (
        <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded bg-white/95 px-2 py-1 text-xs font-semibold text-ink" data-testid={`terminal-historical-badge-${t.slug}`}>
          <History className="h-3.5 w-3.5" aria-hidden="true" /> {t.status_label}
        </span>
      )}
    </div>
    <div className="flex flex-1 flex-col p-5">
      <p className="eyebrow mb-1.5">{t.city}</p>
      <h3 className="text-lg font-semibold leading-snug">{t.name}</h3>
      <p className="mt-2 flex-1 text-[15px] text-ink-muted">{t.summary}</p>
      {stats && <TerminalStats facts={t.facts} />}
      <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-navy">
        Ayrıntılar <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" aria-hidden="true" />
      </span>
    </div>
  </Link>
);
